import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-438674d7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "service_phone"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "service_phone_title mt40 mb40"
}, "联系客服", -1));
const _hoisted_3 = {
  class: "service_phone_main"
};
const _hoisted_4 = {
  class: "flex_FSBC"
};
const _hoisted_5 = {
  class: "flex_size_1 service_phone_main_left"
};
const _hoisted_6 = {
  class: "flex_size_1 service_phone_main_right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.servicePhoneList, item => {
    return _openBlock(), _createElementBlock("p", {
      class: "mb10",
      key: item.customerServiceNumberId
    }, " 名称：" + _toDisplayString(item.customerServiceName), 1);
  }), 128))]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.servicePhoneList, item => {
    return _openBlock(), _createElementBlock("p", {
      class: "mb10 flex_FSBC",
      key: item.customerServiceNumberId
    }, [_createElementVNode("span", null, "联系方式：" + _toDisplayString(item.customerServiceNumber), 1), _createVNode(_component_el_button, {
      text: "",
      onClick: () => $setup.copyPhone(item.customerServiceNumber)
    }, {
      default: _withCtx(() => [_createTextVNode("复制")]),
      _: 2
    }, 1032, ["onClick"])]);
  }), 128))])])])]);
}